import formatDate from '@/services/general/formatIsoDate';
import HTTP from '../HTTP';

const URL_BASE = 'gescom/Disponibilite/';

export async function addDisponibiliteReseau(info) {
  const response = await HTTP.post(URL_BASE + 'AddDisponibiliteReseauAsync', info);
  return response;
}

export async function addDisponibiliteReseauLC(info) {
  const response = await HTTP.post(URL_BASE + 'AddDisponibiliteFaceReseauLcAsync', info);
  return response;
}

export async function addDisponibiliteReseauNumerique(info) {
  const response = await HTTP.post(URL_BASE + 'AddDisponibiliteReseauNumeriqueAsync', info);
  return response;
}

export async function addDisponibiliteEcranNumerique(info) {
  const response = await HTTP.post(URL_BASE + 'AddDisponibiliteEcranNumeriqueAsync', info);
  return response;
}

export async function getDisponibilites(produitId, annee) {
  const response = await HTTP.get(URL_BASE + 'GetDisponibilitesAsync', {
    params: { produitId: produitId, annee: annee },
  });
  return response;
}

export async function getAllPlanning(produitsId, dateDebut, dateFin) {
  const payload = {
    produitsId,
    dateDebut: formatDate(dateDebut),
    dateFin: formatDate(dateFin),
  };
  const response = await HTTP.post(URL_BASE + 'PGetAllPlanningAsync', payload);
  return response;
}

export async function updateAllObjectifDispoAsync(info) {
  const response = await HTTP.put(URL_BASE + 'UpdateAllObjectifDispoAsync', info);
  return response;
}
